import hosts from "constants/hosts"

const getEnvironmentNameFromHost = (host) => {
  if (host?.includes("localhost")) return "local"
  if (host?.includes("manage")) return "prod"
  return host?.split(".")[0]
}

const getHostsByEnvironment = () => {
  const envHost = process.env.REACT_APP_PRO_HOST

  if (!envHost) {
    console.error("REACT_APP_PRO_HOST is not set.")
    return null
  }

  const environmentName = getEnvironmentNameFromHost(envHost)
  const environment = hosts[environmentName]

  if (!environment) {
    console.error(`No matching host found for: ${environmentName}`)
    return null
  }

  return environment
}

export { getHostsByEnvironment }
